import React, { useRef } from 'react'
import YoutubePlayer2 from '../../components/player/VimeoPlayer2';
import HSLplayer from '../../components/player/HSLplayer';


export default function GumletPlayerTest() {

  return (
 <>
  <YoutubePlayer2 type='test' url='https://video.gumlet.io/6785f631b15221f868e9d246/6785f67e7c8406e5491d23bc/main.m3u8'  watchTime={0} />
 </>
  )
}
